import { FC, memo } from 'react';
import { useSelector } from 'react-redux';

import { PlusSubscriptionPlusIcon } from 'src/components/plusSubscription/modals/icons/Plus';
import { deCommonCurrentPartnerSelector } from 'src/store/commonPart/selector';
import styles from 'src/styles/common/plusSubscription/modal/features.module.scss';
import { useNsTHelper } from 'src/utils/i18n';

export const PlusSubscriptionFeatures: FC = memo(() => {
  const tHelper = useNsTHelper('plusSubscription', 'modals.common.features');

  const { Name } = useSelector(deCommonCurrentPartnerSelector);

  const items = [
    'donationPages',
    'donorProfiles',
    'totalCustomBranding',
    'rallyUpEmailEngine',
    'integrations',
    'emailMarketingIntegrations',
  ];

  return (
    <div className={styles.features}>
      {items.map((item) => (
        <div key={item} className={`${styles.item} ${item}`}>
          <PlusSubscriptionPlusIcon className={styles.icon} />
          <div className={styles.caption}>{tHelper(`${item}.caption`, { partnerName: Name })}</div>
          <div className={styles.description}>{tHelper(`${item}.description`, { partnerName: Name })}</div>
        </div>
      ))}
    </div>
  );
});
